import api from "./api";

// Client-side batching + session cache for content translation.
// Multiple <TranslatedText> instances that mount in the same tick are coalesced
// into ONE POST /translate call. Results are cached per text for the session so
// re-renders never re-request (backend also caches permanently).

const resultCache = new Map(); // text -> result object
const inflight = new Map();     // text -> Promise
let queue = [];                 // [{ text }]
let timer = null;

function flushSoon() {
  if (timer) return;
  timer = setTimeout(flush, 80);
}

async function flush() {
  timer = null;
  const batch = queue;
  queue = [];
  const uniq = [...new Set(batch.map((b) => b.text))];
  const items = uniq.map((t, i) => ({ id: String(i), text: t }));
  try {
    const { data } = await api.post("/translate", { items });
    const byId = {};
    (data.results || []).forEach((r) => { byId[r.id] = r; });
    uniq.forEach((t, i) => {
      const res = byId[String(i)] || { translated: false, translated_text: t, source: null };
      resultCache.set(t, res);
      const p = inflight.get(t);
      if (p) p.resolve(res);
      inflight.delete(t);
    });
  } catch (e) {
    void e;
    uniq.forEach((t) => {
      const p = inflight.get(t);
      if (p) p.resolve({ translated: false, translated_text: t, source: null, error: true });
      inflight.delete(t);
    });
  }
}

export function translateText(text) {
  if (!text || !text.trim()) {
    return Promise.resolve({ translated: false, translated_text: text, source: null });
  }
  if (resultCache.has(text)) return Promise.resolve(resultCache.get(text));
  if (inflight.has(text)) return inflight.get(text).promise;
  let resolve;
  const promise = new Promise((res) => { resolve = res; });
  inflight.set(text, { promise, resolve });
  queue.push({ text });
  flushSoon();
  return promise;
}
